module.exports = __webpack_public_path__ + "static/media/amsh-survey.e13fca70.svg";